export default __webpack_public_path__ + "static/media/helis.16a0d367.png";